import objectPath from 'object-path'
import { getCurrentUi, updateUiSchema } from './Data'
import { cloneDeep } from 'lodash'

const convertAPI = (jsonForm) => {
  let apiGroup = jsonForm.apiGroup
  if (apiGroup) {
    apiGroup.map((item) => {
      let { internalApi } = item
      if (internalApi) {
        let { parameters = [], schema = {} } = internalApi
        objectPath.set(item, 'internalApi', { parameters, schema })
      }
      return item
    })
    objectPath.set(jsonForm, 'apiGroup', apiGroup)
  }
  return jsonForm
}

const convertWidget = (jsonForm) => {
  let { schema, uischema } = jsonForm
  let { mapTag } = schema
  let filterWidget = Object.keys(mapTag).filter((key) => {
    let tagName = mapTag[key]
    return tagName === 'widget'
  })
  filterWidget.forEach((key) => {
    let ui = getCurrentUi(key, schema, uischema)
    let widget = cloneDeep(ui.widget)
    if (widget) {
      let { formDesign } = widget
      uischema = updateUiSchema(
        key,
        'widget',
        {
          formDesign,
        },
        jsonForm
      )
    }
  })
  jsonForm.uischema = uischema
  return jsonForm
}

const convertSchema = (jsonForm) => {
  let { schema } = jsonForm
  let { header, body, footer } = schema.properties
  let newProps = {}
  if (header) {
    objectPath.set(newProps, 'header', header)
  }
  if (body) {
    objectPath.set(newProps, 'body', body)
  }
  if (footer) {
    objectPath.set(newProps, 'footer', footer)
  }
  schema.properties = newProps
  jsonForm.schema = schema
  return jsonForm
}

const convertWidgetUischema = (jsonForm, currentUi) => {
  let uischema = jsonForm.uischema
  uischema.elements = [currentUi.ui]
  jsonForm.uischema = uischema
  return jsonForm
}

const convertWidgetSchema = (jsonForm, currentUi) => {
  let { schema } = jsonForm
  let newProps = {}
  let layout = currentUi?.ui?.layout
  if (layout) {
    objectPath.set(newProps, layout, currentUi.schema)
  }
  schema.properties = newProps
  jsonForm.schema = schema
  return jsonForm
}

const isRuntimeJsonForm = (value) => {
  return (
    value &&
    typeof value === 'object' &&
    (objectPath.has(value, 'schema') || objectPath.has(value, 'uischema'))
  )
}

const removeRuntimeJsonForm = (data, checked = new WeakSet()) => {
  if (!data || typeof data !== 'object') return data
  if (checked.has(data)) return data
  checked.add(data)

  if (Array.isArray(data)) {
    data.forEach((item) => removeRuntimeJsonForm(item, checked))
    return data
  }

  Object.keys(data).forEach((key) => {
    if (key === 'jsonForm' && isRuntimeJsonForm(data[key])) {
      delete data[key]
      return
    }
    removeRuntimeJsonForm(data[key], checked)
  })

  return data
}

export const cleanJsonFormRuntimeData = (jsonForm) => {
  let newJsonForm = cloneDeep(jsonForm)
  return removeRuntimeJsonForm(newJsonForm)
}

export const convertJsonForm = (jsonForm, currentUi, isWidget) => {
  jsonForm = cleanJsonFormRuntimeData(jsonForm)
  jsonForm = convertAPI(jsonForm)
  jsonForm = convertWidget(jsonForm)
  if (isWidget) {
    jsonForm = convertWidgetUischema(jsonForm, currentUi)
    jsonForm = convertWidgetSchema(jsonForm, currentUi)
  } else {
    jsonForm = convertSchema(jsonForm)
  }
  return jsonForm
}
